<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    :header="header"

  >
    <div class="sidepanel-body">
      <div class="upload-image-section">
        <div class="upload-image"> 
          <div class="label">
            <label> {{ $t('options.uploadYours') }} </label>
          </div>
          <div class="input-upload mt-2" v-if="user">
            <template v-if="isPremium || user.images.length < allowImages">
              <label class="best-ratio"> {{ $t('options.bestRatio') }} </label><br/>
              <input type="file" ref="fileupload" accept="image/*" id="selectedFile" @change="onFileChange" style="display: none;" />
              <input type="button" :value="$t('options.browseImage')" onclick="document.getElementById('selectedFile').click();" />
            </template>

            <template v-if="!isPremium"> 
              <br/>
              <span class="w-space" v-html="$t('editBackground.allowLimitedImages', {count: allowImages})"></span>
              <img
                  class="ml-1 mr-2 flex-column border-radius premium-logo-design"
                  height="50"
                  srcset="/images/PremiumFavicon.png"
                  alt=""
                />
            </template>

            <template v-if="!isPremium && user.images.length > allowImages"> 
              <span v-if="user.images.length > allowImages"> <br/><br/> {{ $t('editBackground.deleteExtraImages', {count: allowImages}) }} </span>
            </template>
          </div>
          <div class="input-upload mt-2" v-else>
            <label v-html="$t('options.customImageInstruction1')"> </label>
            <label v-html="$t('options.customImageInstruction2')"> </label>
            <label> {{ $t('options.customImageInstruction3') }} </label>
          </div>
        </div>
        <div class="image-preview-section mt-3" v-if="url">
          <div class="image-preview"> 
            <label> <i>{{ $t('options.imagePreview') }}</i> </label>
            <img class="img-width small-width" :src="url" />
          </div>
          <div class="image-upload">
            <p> {{ fileName }} </p>
            <Btn
              @click.native="uploadImage"
              :label="$t('options.addYourImage')"
              class="mt-2"
              :loading="isUploading"
            />
          </div>
        </div>
      </div>

      <div class="panel-section-header text-panel-section-header mt-2">
        {{ $t('options.yourImages') }}
      </div>

      <div class="image-galery" v-if="displayUser && displayUser.images.length > 0">
        <div
          v-for="image in displayUser.images"
          :key="image.id"
          class="bg-image"
        >
          <img loading="lazy" @click="select(image, 'custom')" class="img-width" :src="imageName(image.url, true)" />
          <div v-if="image.id == selected" class="icons">
            <font-awesome-icon class="" :icon="['fal', 'check']" />
          </div>
          <div class="icons right-icons" @click="deleteImage(image.id)">
            <font-awesome-icon class="" :icon="['fal', 'times']" />
          </div>
        </div>
      </div>

      <div class="mt-3 ml-3" v-else>
        <p> {{ $t('options.notUploadedBackgroundImage') }} </p>
      </div>

      <div class="panel-section-header text-panel-section-header mt-2">
        {{ $t('options.standardImages') }}
      </div>

      <div class="image-galery">
        <div
          @click="select(image, 'standard')"
          v-for="image in images"
          :key="image.id"
          class="bg-image"
        >
          <img loading="lazy" class="img-width" :src="imageName(image.url)" />
          <div v-if="image.id == selected" class="icons">
            <font-awesome-icon class="" :icon="['fal', 'check']" />
          </div>
        </div>
      </div>
    </div>

    <ModalDialog
      ref="dlgMaximumImageUpload"
      :title="dialogContent.title"
      :labelOk="dialogContent.okLabel"
      :labelCancel="dialogContent.cancelLabel"
      :showCancelIcon="true"
      :displayCancelButton="true"
      @ok="redirectToMembership()"
      @cancel="whenCancel('onlyClose')"
      :displayOkButton="true" 
    >
    <!-- replace true with isPaymentComplete in displayOkButton -->
      <div class="text-small" v-html="dialogContent.description"></div>
    </ModalDialog>

  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import { pollMixin } from '@/components/mixins/PollMixins.js';
import { mapState, mapGetters, mapActions } from 'vuex';
import { HTTP } from '@/shared/http';
import { constants } from '@/shared/constant';

export default {
  name: 'EditKulibriBackground',
  mixins: [pollMixin],
  props: [],

  components: {
    SidePanel,
  },

  data() {
    return {
      localDetails: null,
      selected: -1,
      // backgroundThumbnail: '/images/thumbnail.webp',
      url: '',
      fileName: '',
      formData: new FormData(),
      isUploading: false,
      displayUser: this.user,
      dialogContent: {title: '', description: '', cancelLabel: '', okLabel: ''},
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      user: (state) => state.Login.user,
    }),

    ...mapGetters(['images', 'bgDefaultImage', 'bgDeleteDefaultImage', 'isPremium', 'getCurrentDisplayUser']),

    header() {
      return this.$t('options.selectImage')
    },
    cancelText() {
      return 'Zurück';
    },
    allowImages() {
      return constants.freeImages
    }
  },

  methods: {
    ...mapActions(['addImageInUserImages', 'replaceImagesToUserImagesObject']),

    select(image, type = 'standard') {
      console.log("select image:", image);
      if(type === 'standard' || this.isPremium || !this.displayUser.images || this.displayUser.images.length <= this.allowImages) {        
        this.selected = image.id;
        this.$store.commit('setBgImage', image);
      } else {
        this.dialogContent.title = this.$t('customBrandingTemplate.premiumFeature');
        this.dialogContent.description = this.$t('editBackground.deleteExtraImages', {count: this.allowImages});
        this.dialogContent.okLabel = this.$t('customBrandingTemplate.checkMyStatus');
        this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
        this.$refs.dlgMaximumImageUpload.openModal();
      }
    },

    onCancel() {
      // save the current selected background
      this.$emit('cancel');
    },
    imageName(url, custom = false) {
      if(url) {
        let smUrl = '';
        if(custom == false) {
          smUrl = url.replace('/images/', '/images/sm_');
        } else {
          smUrl = url.replace('/storage/', '/storage/sm_');
        }
        return smUrl;
      }
      return null;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if(file) {
        this.fileName = e.target.files[0].name;
        this.url = URL.createObjectURL(file);
        this.formData.append("file", file);
      } else {
        this.reset();
      }
    },
    uploadImage() {
      this.isUploading = true;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/image/upload';
      HTTP.post(url, this.formData)
        .then((response) => {
          this.reset();
          if(response.data) {
            this.addImageInUserImages(response.data);
          }
        })
        .catch((err) => {
          this.reset();
          // console.log(err);
          this.dialogContent.title = this.$t('customBrandingTemplate.premiumFeature');
          if(err.response.data.status == true) {
            this.dialogContent.description = this.$t('customBrandingTemplate.packageExpired', {limit: err.response.data.limit});
          } else {
            this.dialogContent.description = this.$t('customBrandingTemplate.backgroundImageLimit', {limit: err.response.data.limit});
          }
          this.dialogContent.type = 'payment';
          this.dialogContent.okLabel = this.$t('customBrandingTemplate.checkMyStatus');
          this.dialogContent.cancelLabel = this.$t('customBrandingTemplate.stayHere');
          this.$refs.dlgMaximumImageUpload.openModal();
          // alert(this.$t("options.maxImageLimit", {count: err.response.data.limit}));
        });
    },
    deleteImage(id) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/image/delete/' + id;
      HTTP.post(url, {
          default: this.bgDeleteDefaultImage.url
        })
        .then((response) => {
          this.replaceImagesToUserImagesObject(response.data);
          if(this.selected == id) {
            this.selected = this.bgDeleteDefaultImage.id;
            this.select(this.bgDeleteDefaultImage);
          }
        })
        .catch((err) => {
          alert(this.$t(err.response.data.error));
        });
    },
    reset() {
      this.url = null;
      this.formData.delete('file');
      this.$refs.fileupload.value=null;
      this.isUploading = false;
    },
    redirectToMembership() {
      this.$router.push('/membership');
    },
    openLogin() {
      let redirectUrl = this.$route.path;
      if( redirectUrl ) {
        const pathArray = redirectUrl.split('/');
        redirectUrl = '/pr/' + pathArray[2];
      }

      this.$router.push({
        path: '/signin?url=' + redirectUrl,
        redirect: redirectUrl,
        props: true,
      });
    },
    whenCancel() {
      this.$refs.dlgMaximumImageUpload.closeModal();
    },
  },

  mounted() {
    if(this.poll.bg_image_path) {
      const curImagePath = this.poll.bg_image_path;
      let userImages = this.user ? this.user.images : [];
      this.selected = this.findImageFromListUsingURL(this.images, userImages, curImagePath);
    } else {
      this.selected = this.bgDefaultImage.id;
    }

    let customLink = document.querySelectorAll('.custom-link');
    customLink.forEach(el => {
      if(el.innerText.toLowerCase().includes("upgrade to")) {
        el.addEventListener('click', this.redirectToMembership);  
      } else {
        el.addEventListener('click', this.openLogin);
      }
    });

    // This is used to display the images of the user.
    // check if user is logged In, if not then we can update the display user (participant/admin) updated from the poll
    if(this.user) {
      this.displayUser = this.user;
    } else {
      this.displayUser = this.getCurrentDisplayUser;
    }

  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';
input.form-control:focus {
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
    0 0 0px rgba(126, 239, 104, 0.6);
  outline: 0 none;
}

.image-galery {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.bg-image {
  padding: 7px;
  position: relative;

}

.img-width {
  //width: 240px;
  width: 234px;
  height: 160px;
  border: solid 0px gray;
  border-radius: 15px;
}

.icons {
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: black;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.12);
  background-color: $user-bubble;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  &.right-icons {
    right: 20px !important;
    left: unset;
    cursor: pointer;
  }
}

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.image-preview-section {
  display: flex;
  font-size: $very-small;
  .image-preview {
    display: grid;
  }
  .image-upload {
    margin: auto;
    margin-left: 20px;
    font-size: $very-small;
    text-align: left;
    P {
      margin-bottom: 0px;
    }
  }
}

.input-upload {
  input[type=button] {
    background-color: $light-grey;
    border-radius: 5px;
    font-size: $very-small;
  }
  label.best-ratio {
    font-size: $very-small;
  }
}

.label {
  display: grid;
  label {
    font-weight: $semi-bold-weight;
    margin-bottom: 0px;
  }
}

@media screen and (max-width: 480px) {
  .small-width {
    width: 180px;
    height: 120px;
  }
}
</style>
